import PropTypes from "prop-types";
import React from "react";

import styled from "styled-components/macro";

import { AnimatePresence, motion } from "framer-motion";

export default function ImageVideoSectionSettingsError({
  hasError,
  error,
  ...rest
}) {
  return (
    <AnimatePresence>
      {hasError && (
        <Error
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3 }}
          {...rest}
        >
          <i
            className="fas fa-exclamation-triangle"
            style={{ marginTop: "3px" }}
          />
          {error}
        </Error>
      )}
    </AnimatePresence>
  );
}

ImageVideoSectionSettingsError.propTypes = {
  hasError: PropTypes.bool.isRequired,
  error: PropTypes.string,
  absolutePosition: PropTypes.bool,
};

const Error = styled(motion.div)`
  display: flex;
  align-items: center;
  gap: 8px;
  max-width: 600px;
  padding: 2px 5px;
  border: 1px solid #d5a223;
  border-radius: 5px;
  background-color: #f7f0b6;
  color: #d5a223;
  margin-top: 8px;
  box-sizing: border-box;
`;